import { createSlice } from '@reduxjs/toolkit';
import { createTransaction, ITransaction } from '../../../models/transactions';

interface ITransactionState {
    transactions: ITransaction[],
    transaction: ITransaction,
    isLoading: boolean,
};

const initialState: ITransactionState = {
    transactions: [],
    transaction: createTransaction({}),
    isLoading: false,
};

export const transactionsSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {
        setTransactions: (state, action) => {
            state.isLoading = false;
            state.transactions = action.payload.transactions;
        },
        startLoadingTransactions: (state) => {
            state.isLoading = true;
        }
    }
});

// Action creators are generated for each case reducer function
export const {
    setTransactions,
    startLoadingTransactions
} = transactionsSlice.actions;